import React, { Component } from "react";
import { TableDefault, LabelString, LabelDollarFormatted, LabelDate } from "@loanbossinc/component-library";
import moment from 'moment';
import { findHedgeValue, getHedgeEscrow } from "./activeLoanHedges.filters";
import styled from "styled-components";
import { StyledRateOrStrike } from "./StyledDataTableHelper";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import { getEnvConfig } from "helpers/environment-config";
import { convertIntegerToGUID } from "helpers/guid";

const StyledTableDefault = styled(TableDefault)`
&& {
    border-radius: 0px; 
    tr:last-child {
        td {
            border-bottom: #DADCE0 1px solid;
        }
      }
}
`;

const DisplayPill = styled.span`
&& {
    font-family: Work Sans;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 12px;
    letter-spacing: 0em;
    text-align: left;
    background-color: #DADCE0;
    border-radius: 4px;
    color:#005AA9;
    display:inline-block;
    height:15px;
    margin: 1em;
    padding: 0.5em;
}`;

const convertDealIdToGuid = (value) => {
    if (!isNaN(Number(value)) && Number.isInteger(Number(value))) {
        return convertIntegerToGUID(Number(value));
    }
    return value;
};

class ActiveHedgeDataTable extends Component {
    activeHedgeCols = () => {
        return [
            {
                id: 'hedgeName'
                , label: 'ACTIVE HEDGES'
                , path: 'hedgeName'
                , Cell: (value) => (
                    <div style={{ display: "flex" }}>
                        <LabelString style={{ color: "#000", fontWeight: "500", width: "100px" }} value={value.name} />
                        {value.escrowUrl && <DisplayPill onClick={(event) => {
                            event.stopPropagation();
                            this.props.history.push(value.escrowUrl);
                        }}>ESCROW</DisplayPill>
                        }
                    </div>
                )
            }
            , {
                id: 'rateOrStrike'
                , label: 'RATE/STRIKE'
                , path: 'rateOrStrike'
                , Cell: (value) => (<StyledRateOrStrike value={value} />)
            }
            , {
                id: 'termination'
                , label: 'TERMINATION'
                , path: 'termination'
                , align: 'center'
                , Cell: (value) => (<LabelDate value={value} />)
            }
            , {
                id: 'markToMarket'
                , label: 'MtM'
                , path: 'markToMarket'
                , align: 'right'
                , Cell: (value) => (<LabelDollarFormatted value={value} decimals={0} />)
            }
        ]
    }

    getColumnData = () => {
        const { activeHedges } = this.props;
        return activeHedges.reduce((acc, cur) => {
            acc.push({
                hedgeId: cur.id
                , dealId: cur.dealId
                , hedgeName:
                {
                    name: `${cur.hedgeProvider ? cur.hedgeProvider.name : cur.hedgeStatus ? cur.hedgeStatus.value : ""} - ${cur.hedgeType ? cur.hedgeType.value : ""}`
                    , escrowUrl: getHedgeEscrow(cur)
                }
                , rateOrStrike: findHedgeValue(cur)
                , termination: cur.terminationDate ? moment(cur.terminationDate).format('MM/DD/YYYY') : null
                , markToMarket: cur.markToMarket
            });
            return acc;
        }, []);
    }

    handleRowClick = async (hedge) => {
        const { history, flags } = this.props;

        if (flags.bar2105RedirectToNewHedgeViewPage) {
            const newFrontendUrl = await getEnvConfig("newFrontendUrl");
            const dealIdGuid = convertDealIdToGuid(hedge.dealId);
            window.location.assign(`${newFrontendUrl}/deals/${dealIdGuid}/hedges/${hedge.hedgeId}`);
        } else {
            history.push(`/hedges/${hedge.hedgeId}`);
        }
    };

    render() {
        return (
            <div>
                <StyledTableDefault
                    addDropShodow
                    elevation={0}
                    columns={this.activeHedgeCols()}
                    items={this.getColumnData()}
                    onRowClick={this.handleRowClick} />
            </div>
        );
    }
}

const ActiveHedgeDataTableWithFlags = withLDConsumer()(ActiveHedgeDataTable);
export { ActiveHedgeDataTableWithFlags as ActiveHedgeDataTable };
export default ActiveHedgeDataTableWithFlags;
